import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { type SxProps } from '@mui/system/styleFunctionSx'
import { math } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'
import { FOCUS_OFFSET, getFocusVisibleStyle } from '@Styles/focus'
import { type SeverityType } from '@Types/severity'
import { getBackgroundColorBySeverity } from '@Utils/severity'

const OUTLINE_RADIUS = math(`${RADIUS_1} - ${FOCUS_OFFSET}`)

export const container = (theme: Theme, severity: SeverityType, hasBottomBorderRadius = false): SerializedStyles =>
  css({
    '&:focus-visible': {
      '&::before': getFocusVisibleStyle(
        theme.palette.primary.main,
        hasBottomBorderRadius ? `0 0 ${OUTLINE_RADIUS} ${OUTLINE_RADIUS}` : '0',
        '0',
      ),
      outline: 'none',
    },
    backgroundColor: getBackgroundColorBySeverity(theme, severity),
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    position: 'relative',
  })

export const commonStyles = (
  theme: Theme,
  hasBottomBorderRadius = false,
  hasBorder = false,
  isElevated = false,
): SxProps => ({
  overflow: 'hidden',
  ...(hasBorder && {
    border: 2,
    borderColor: isElevated ? theme.customPalette.background.default : theme.customPalette.background.paper,
  }),
  ...(hasBottomBorderRadius && {
    borderBottomLeftRadius: RADIUS_1,
    borderBottomRightRadius: RADIUS_1,
  }),
})
